// src/components/report/TeacherFeedbackPage.jsx - Fixed with proper data mapping
import React from 'react';

// Smiley Icons for assessment - with proper selection highlighting
const SmileyIcon = ({type, selected = false, size = 24}) => {
    const baseStyle = selected ? 'ring-2 ring-blue-500' : '';
    const icons = {
        happy: (
            <div
                className={`w-6 h-6 rounded-full bg-yellow-400 border border-gray-300 flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4">
                    <circle cx="8" cy="9" r="1" fill="#000"/>
                    <circle cx="16" cy="9" r="1" fill="#000"/>
                    <path d="M8 15s1.5 2 4 2 4-2 4-2" stroke="#000" strokeWidth="1.5" fill="none"/>
                </svg>
            </div>
        ),
        neutral: (
            <div
                className={`w-6 h-6 rounded-full bg-yellow-400 border border-gray-300 flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4">
                    <circle cx="8" cy="9" r="1" fill="#000"/>
                    <circle cx="16" cy="9" r="1" fill="#000"/>
                    <line x1="8" y1="15" x2="16" y2="15" stroke="#000" strokeWidth="1.5"/>
                </svg>
            </div>
        ),
        question: (
            <div
                className={`w-6 h-6 rounded-full bg-yellow-400 border border-gray-300 flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4">
                    <circle cx="8" cy="9" r="1" fill="#000"/>
                    <circle cx="16" cy="9" r="1" fill="#000"/>
                    <text x="12" y="16" textAnchor="middle" fontSize="8" fill="#000">?</text>
                </svg>
            </div>
        )
    };
    return icons[type] || icons.happy;
};

// Resource Icons - with proper selection highlighting
const ResourceIcon = ({type, selected = false, size = 24}) => {
    const baseStyle = selected ? 'ring-2 ring-blue-500' : '';
    const icons = {
        classmate: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#3B82F6" strokeWidth="1.5">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
            </div>
        ),
        teacher: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#8B5CF6" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                </svg>
            </div>
        ),
        books: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#10B981" strokeWidth="1.5">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
            </div>
        ),
        computer: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#6B7280" strokeWidth="1.5">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
            </div>
        ),
        none: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#EF4444" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
            </div>
        ),
        'books/magazine': (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#F97316" strokeWidth="1.5">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
            </div>
        ),
        newspaper: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#F97316" strokeWidth="1.5">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
            </div>
        ),
        'toys/games/sports': (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#F97316" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="3"/>
                    <path
                        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
            </div>
        ),
        'phone/computer': (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#F97316" strokeWidth="1.5">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                    <line x1="12" y1="18" x2="12.01" y2="18"/>
                </svg>
            </div>
        ),
        internet: (
            <div
                className={`w-6 h-6 rounded-full border border-gray-300 bg-white flex items-center justify-center ${baseStyle}`}>
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="#F97316" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="2" y1="12" x2="22" y2="12"/>
                    <path
                        d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
            </div>
        )
    };
    return icons[type] || icons.books;
};

// Proficiency Diagram with realistic landscape and proficiency marks highlighting
const ProficiencyDiagram = ({proficiencyMarks}) => {
    const getHighlightStyle = (level) => {
        const hasMarkForLevel = proficiencyMarks?.some(mark => mark.level === level);
        return hasMarkForLevel ? 'ring-4 ring-red-500' : '';
    };

    return (
        <div className="relative w-40 h-40 mx-auto">
            <div className="w-full h-full rounded-full overflow-hidden border-2 border-gray-400 relative"
                 style={{
                     background: 'linear-gradient(to bottom, #87CEEB 0%, #87CEEB 30%, #90EE90 30%, #90EE90 60%, #4682B4 60%, #4682B4 100%)'
                 }}>
                {/* Sky section - with highlighting if selected */}
                <div
                    className={`absolute top-3 left-1/2 transform -translate-x-1/2 font-bold text-blue-800 text-sm ${getHighlightStyle('Sky')}`}>
                    Sky
                </div>

                {/* Mountain section - with highlighting if selected */}
                <div
                    className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-bold text-green-800 text-sm ${getHighlightStyle('Mountain')}`}>
                    Mountain
                </div>

                {/* Stream section - with highlighting if selected */}
                <div
                    className={`absolute bottom-3 left-1/2 transform -translate-x-1/2 font-bold text-blue-800 text-sm ${getHighlightStyle('Stream')}`}>
                    Stream
                </div>

                {/* Levels of Proficiency vertical text */}
                <div
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 -rotate-90 font-bold text-blue-800 text-xs whitespace-nowrap">
                    Levels of Proficiency
                </div>

                {/* Vertical arrow */}
                <div className="absolute left-4 top-6 bottom-6 w-0.5 bg-blue-800"></div>
                <div
                    className="absolute left-4 top-6 w-0 h-0 border-l-2 border-r-2 border-b-4 border-l-transparent border-r-transparent border-b-blue-800 transform rotate-180"></div>
            </div>
        </div>
    );
};

const TeacherFeedbackPage = ({assignment, pageNumber}) => {
    if (!assignment) return <div className="report-page">Loading Feedback...</div>;

    // Extract assessment data
    const selfAssessment = assignment.self_assessment || {};
    const peerAssessment = assignment.peer_assessment || {};
    const caregiverObservation = assignment.caregiver_observation || {};
    const proficiencyMarks = assignment.proficiency_marks || [];

    return (
        <div className="report-page relative bg-white" style={{
            width: '210mm',
            height: '297mm',
            minHeight: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.4',
            fontFamily: 'Arial, Helvetica, sans-serif',
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden'
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                 style={{
                     borderTop: '60px solid #F97316',
                     borderLeft: '60px solid transparent'
                 }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                 style={{
                     borderBottom: '60px solid #F97316',
                     borderRight: '60px solid transparent'
                 }}>
            </div>

            {/* Teacher's Feedback Header */}
            <div className="bg-orange-600 text-white py-3 px-4 text-center font-bold text-lg mb-4"
                 style={{backgroundColor: '#EA580C', marginLeft: '-20mm', marginRight: '-20mm'}}>
                TEACHER'S FEEDBACK
            </div>

            {/* Top section - Proficiency diagram and Observational Notes */}
            <div className="flex mb-4 border-2 border-orange-400">
                {/* Left column - Proficiency diagram */}
                <div className="w-1/2 p-4 border-r-2 border-orange-400 bg-orange-50">
                    <div className="font-bold mb-3 text-sm">
                        NOTE: For each ability, mark the appropriate level
                    </div>
                    <ProficiencyDiagram proficiencyMarks={proficiencyMarks}/>
                </div>

                {/* Right column - Observational Notes */}
                <div className="w-1/2 p-4 bg-orange-50">
                    <div className="font-bold mb-3 text-sm">Observational Notes</div>
                    <div className="bg-white border border-gray-300 p-3 text-sm" style={{minHeight: '150px'}}>
                        {assignment.observational_notes || assignment.teacher_feedback || ''}
                    </div>
                </div>
            </div>

            {/* Circle instruction */}
            <div className="mb-3 text-sm">
                <span
                    className="inline-flex items-center justify-center rounded-full border-2 border-black w-5 h-5 text-xs mr-2">
                    ⭘
                </span>
                the picture that shows how you worked on this activity.
            </div>

            {/* Self Assessment Section */}
            <div className="mb-2">
                <div className="flex border-2 border-gray-400">
                    {/* Self Assessment Label */}
                    <div
                        className="w-1/6 bg-purple-600 text-white flex items-center justify-center py-8 px-2 text-center font-bold text-sm">
                        Self Assessment
                    </div>

                    {/* I liked doing this work */}
                    <div className="w-1/6 bg-green-500 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">I liked doing this work.</div>
                        <div className="bg-green-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="happy" selected={selfAssessment.liked === true}/>
                                <span className="text-xs text-black mt-1">yes</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="neutral" selected={selfAssessment.liked === false}/>
                                <span className="text-xs text-black mt-1">no</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="question" selected={selfAssessment.liked === null}/>
                                <span className="text-xs text-black mt-1">do not know</span>
                            </div>
                        </div>
                    </div>

                    {/* I found this work easy */}
                    <div className="w-1/6 bg-pink-500 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">I found this work easy.</div>
                        <div className="bg-pink-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="happy" selected={selfAssessment.easy === true}/>
                                <span className="text-xs text-black mt-1">yes</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="neutral" selected={selfAssessment.easy === false}/>
                                <span className="text-xs text-black mt-1">no</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="question" selected={selfAssessment.easy === null}/>
                                <span className="text-xs text-black mt-1">do not know</span>
                            </div>
                        </div>
                    </div>

                    {/* To do this work, I needed... */}
                    <div className="w-1/2 bg-blue-500 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">To do this work, I needed...</div>
                        <div className="bg-blue-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="classmate" selected={selfAssessment.needed?.includes('classmate')}/>
                                <span className="text-xs text-black mt-1">Classmate</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="teacher" selected={selfAssessment.needed?.includes('teacher')}/>
                                <span className="text-xs text-black mt-1">teacher</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="books" selected={selfAssessment.needed?.includes('books')}/>
                                <span className="text-xs text-black mt-1">books</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="computer" selected={selfAssessment.needed?.includes('computer')}/>
                                <span className="text-xs text-black mt-1">computer</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="none" selected={selfAssessment.needed?.includes('none')}/>
                                <span className="text-xs text-black mt-1">none</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Black divider line */}
            <div className="h-1 bg-black my-2"></div>

            {/* Circle instruction for peer assessment */}
            <div className="mb-3 text-sm">
                <span
                    className="inline-flex items-center justify-center rounded-full border-2 border-black w-5 h-5 text-xs mr-2">
                    ⭘
                </span>
                the picture that shows how your friend worked on this activity.
            </div>

            {/* Peer Assessment Section */}
            <div className="mb-4">
                <div className="flex border-2 border-gray-400">
                    {/* Peer Assessment Label */}
                    <div
                        className="w-1/6 bg-blue-600 text-white flex items-center justify-center py-8 px-2 text-center font-bold text-sm">
                        Peer Assessment
                    </div>

                    {/* My friend liked doing this work */}
                    <div className="w-1/6 bg-green-600 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">My friend liked doing this work.</div>
                        <div className="bg-green-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="happy" selected={peerAssessment.friend_liked === true}/>
                                <span className="text-xs text-black mt-1">yes</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="neutral" selected={peerAssessment.friend_liked === false}/>
                                <span className="text-xs text-black mt-1">no</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="question" selected={peerAssessment.friend_liked === null}/>
                                <span className="text-xs text-black mt-1">do not know</span>
                            </div>
                        </div>
                    </div>

                    {/* My friend found this work easy */}
                    <div className="w-1/6 bg-pink-600 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">My friend found this work easy.</div>
                        <div className="bg-pink-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="happy" selected={peerAssessment.friend_easy === true}/>
                                <span className="text-xs text-black mt-1">yes</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="neutral" selected={peerAssessment.friend_easy === false}/>
                                <span className="text-xs text-black mt-1">no</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <SmileyIcon type="question" selected={peerAssessment.friend_easy === null}/>
                                <span className="text-xs text-black mt-1">do not know</span>
                            </div>
                        </div>
                    </div>

                    {/* To do this work, My friend needed... */}
                    <div className="w-1/2 bg-blue-500 text-white p-2 text-center">
                        <div className="font-bold mb-2 text-xs">To do this work, My friend needed...</div>
                        <div className="bg-blue-100 py-2 px-1 flex justify-around items-center">
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="classmate"
                                              selected={peerAssessment.friend_needed?.includes('classmate')}/>
                                <span className="text-xs text-black mt-1">Classmate</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="teacher"
                                              selected={peerAssessment.friend_needed?.includes('teacher')}/>
                                <span className="text-xs text-black mt-1">teacher</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="books" selected={peerAssessment.friend_needed?.includes('books')}/>
                                <span className="text-xs text-black mt-1">books</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="computer"
                                              selected={peerAssessment.friend_needed?.includes('computer')}/>
                                <span className="text-xs text-black mt-1">computer</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <ResourceIcon type="none" selected={peerAssessment.friend_needed?.includes('none')}/>
                                <span className="text-xs text-black mt-1">none</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Parents/Caregiver/Guardian's Observation */}
            <div className="flex border-2 border-orange-400">
                {/* Left column - Parents/Caregiver/Guardian's Observation */}
                <div className="w-1/2 p-4 border-r-2 border-orange-400 bg-orange-50">
                    <div className="font-bold text-orange-800 mb-3 text-sm">Parents/Caregiver/Guardian's Observation
                    </div>

                    <div className="mb-3 text-sm">
                        <span
                            className="inline-flex items-center justify-center rounded-full border-2 border-black w-5 h-5 text-xs mr-2">
                            ⭘
                        </span>
                        the relevant response
                    </div>

                    {/* Learning Teaching resources at home */}
                    <div className="bg-blue-600 text-white p-2 rounded-t-lg text-center">
                        <div className="font-bold text-xs">
                            Learning Teaching resources at home
                        </div>
                    </div>

                    <div className="bg-white p-3 rounded-b-lg border-2 border-blue-300">
                        <div className="flex justify-around items-center">
                            {[
                                {type: 'books/magazine', label: 'books/magazine'},
                                {type: 'newspaper', label: 'newspaper'},
                                {type: 'toys/games/sports', label: 'toys/games/sports'},
                                {type: 'phone/computer', label: 'phone/computer'},
                                {type: 'internet', label: 'internet'}
                            ].map((resource, idx) => (
                                <div key={idx} className="flex flex-col items-center">
                                    <ResourceIcon
                                        type={resource.type}
                                        selected={caregiverObservation.resources?.includes(resource.type)}
                                    />
                                    <span className="text-xs text-black mt-1 text-center leading-tight">
                                        {resource.label.split('/')[0]}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right column - Comments/Remarks */}
                <div className="w-1/2 p-4 bg-orange-50">
                    <div className="font-bold text-orange-800 mb-3 text-sm">Comments/Remarks</div>
                    <div className="border border-gray-300 bg-white p-3 text-sm" style={{minHeight: '120px'}}>
                        {caregiverObservation.comments || ''}
                    </div>
                </div>
            </div>

            {/* Page number */}
            {pageNumber && (
                <div className="absolute bottom-4 left-0 right-0 text-center text-sm font-medium">
                    {pageNumber}
                </div>
            )}
        </div>
    );
};

export default TeacherFeedbackPage;